import React, {type ElementType, Fragment} from 'react';

import type {ContentType} from 'sweet-types';

type Props<T> = {
  object: T;
  activeRelations?: Record<ContentType, boolean> | Record<string, boolean>;
  relations: Array<{
    ct: ContentType;
    Component: ElementType;
    getter: (p) => Array<unknown> | void;
  }>;
};

export function ItemRelationsLists<T>({
  object,
  relations,
  activeRelations,
}: Props<T>) {
  return (
    <Fragment>
      {relations.map(({ct, getter, Component}) =>
        activeRelations != null && activeRelations[ct] === true ? (
          <Component key={ct} items={getter(object)} contentType={ct} />
        ) : null
      )}
    </Fragment>
  );
}
